import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styles from "../checkout.module.css";
import { useHistory, useLocation } from "react-router-dom";
import { ROUTE } from "../../../route/Route";
import { getUser } from "../../../constant/utils";
import { checkOutAction, profileAction } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { cartListResponse } from "../../../redux/profile/reducer";
interface ICardBox {
  totalPayble: number;
  setTotalPayble: (val: number) => void;
  bookingData: any;
  setBookingData: (val: any) => void;
  bookingValidation: any;
  cardEntry:any[], 
  setCardEntry: (val: any) => void;
}

const CartBox = ({cardEntry, setCardEntry, totalPayble = 0, setTotalPayble, bookingData, setBookingData, bookingValidation }: ICardBox) => {
  const USER: any = getUser();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<any>();
  const [coupen, setCoupen] = useState<any>("");
  const [homeCollectionAmount, setHomeCollectionAmount] = useState<any>(0);
  const [apply, setApply] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const CityId: any = localStorage.getItem("oq:city");
  const getCartData: any = useSelector((state: any) => state.profile.cartList);
  let cart_data_local = localStorage.getItem("CartData");
  useEffect(() => {
    if (bookingValidation?.homeCollectionCharges?.price) {
      setHomeCollectionAmount(bookingValidation.homeCollectionCharges.price);
    }
  }, [bookingValidation]);

  useEffect(() => {
    if (getCartData) {
      setCardEntry(JSON.parse(localStorage.getItem("CartData") || "[]"));
    }
  }, [getCartData]);

  useEffect(() => {
    if (location?.state?.data?.Id) {
      addToCart(location?.state?.type, location?.state?.data);
    }
  }, [location?.state?.data]);

  useEffect(() => {
    if (cardEntry && Array.isArray(cardEntry) && cardEntry?.length == 0 && bookingData?.isBookingEdit) {
      localStorage.removeItem("editBooking");
      setBookingData({ tab: bookingData?.tab });
    }
    if (cardEntry && Array.isArray(cardEntry) && cardEntry?.length > 0 && USER?.Id && CityId) {
      dispatch(
        checkOutAction.storeCartDataAction({
          SessionId: uuidv4(),
          UserId: USER?.Id,
          CartData: cardEntry,
          CityId:CityId
        })
      );
    }
  }, [cardEntry, USER?.Id]);

  const handleRemoveCoupen = () => {
    setOpen(false);
    setCoupen("");
    setApply(false);
  };
  const handleApplycoupen = () => {
    setApply(true);
  };
  const getCartTotal = (apply: any) => {
    let couponDis: number = apply ? 100 : 0;
    setTotalPayble(
      cartTotal() >= 1500 || cartTotal() == 0 ? cartTotal() - couponDis : cartTotal() - couponDis + homeCollectionAmount
    );
  };

  useEffect(() => {
    if (cardEntry) {
      getCartTotal(apply);
    }
  }, [cardEntry, apply, homeCollectionAmount]);

  const getCityPrice = (cityPrice: any[] = []) => {
    let _price =
      CityId &&
      cityPrice?.length > 0 &&
      cityPrice?.find((ele: any) => ele?.availability == 1 && CityId == ele?.city_id);
    return _price?.city_price;
  };
  const addToCart = (type: any, data: any) => {
    let CityPrice: any = getCityPrice(data?.CitywisePrices) || data?.SellingPrice || 0;
    let CartData: any[] = [...cardEntry];
    CartData.push({
      Id: data?.TestCode || data?.PackageCode,
      TestCode: data?.TestCode || data?.PackageCode,
      TestName: data?.TestName || data?.PackageName,
      MRP: data?.MRP,
      SellingPrice: CityPrice,
      Type: type,
      Gender: data?.Gender,
    });
    setCardEntry(CartData);
    setBookingData({ ...bookingData, CardData: CartData });
    localStorage.setItem("CartData", JSON.stringify(CartData));
    window.history.replaceState({}, "");
  };
  const removeFromCart = (data: any) => {
    let CartData: any[] = [...cardEntry];
    let newArr: any[] = CartData?.filter((ele: any) => !(ele?.Id == data?.Id && ele?.Type == data?.Type));
    localStorage.setItem("CartData", JSON.stringify(newArr));
    setCardEntry(newArr);
    setBookingData({ ...bookingData, CardData: newArr });
  };
  const cartTotal = (mrp: boolean = false) => {
    return cardEntry?.reduce((total, item) => Number(mrp ? item?.MRP : item?.SellingPrice) + total, 0);
  };

  return (
    <div>
      <div className={styles.cartHeading}>Cart(Test/Package)</div>
      <div className={styles.cardDes}>
        <div>
          {cardEntry?.length > 0 ? (
            cardEntry?.map((item: any, index: any) => (
              <div className={styles.cardItem}>
                <div>
                  <img src="/assets/img/my-profile/delete.png" onClick={() => removeFromCart(item)} />
                  {item?.TestName}({item?.Type})
                </div>
                <div className={styles.rate}>₹{item?.SellingPrice || 0}</div>
              </div>
            ))
          ) : (
            <div className="font-weight-bold text-center fs-16 my-2">No Test/Package Added</div>
          )}
        </div>
        <div className="text-right">
          <a
            href=""
            style={{ padding: "5px 20px", margin: "10px 0px" }}
            className="book--hexagon active"
            onClick={(e: any) => {
              e.preventDefault();
              history.push(ROUTE.BOOKATEST, {
                tabs: "",
                categoryId: "",
                subCategoryId: "",
              });
            }}
          >
            <span className="text-capitalize">
              <img className="mr-2" src="assets/img/my-profile/white-plus.png" aria-hidden="true" />
              {cardEntry?.length > 0 ? "Add More" : "Add"}
            </span>
          </a>
        </div>
        {cardEntry?.length > 0 && (
          <React.Fragment>
            <div>
              <div className={styles.cardItem}>
                <div>Sub Total</div>
                <div className={styles.rate}>₹{cartTotal()}</div>
              </div>

              <div className={styles.cardItem}>
                <div>Home Collection Fee*</div>
                <div className={styles.rate}>{cartTotal() >= 1500 ? "Free" : `₹${homeCollectionAmount}`}</div>
              </div>
                <div style={{fontWeight:"500", color:"red",fontSize:"12px"}}>*These Charges are applicable in order value less than ₹1500.</div>
              {/* <div className={styles.cardItem}>
                {!open && !apply && (
                  <p
                    className={styles.coupenHaveText}
                    onClick={() => setOpen(!open)}
                  >
                    I have a coupon code
                  </p>
                )}
                {open && !apply && (
                  <div className={styles.applyCoupen}>
                    <div>
                      <input
                        value={coupen}
                        onChange={(e: any) => setCoupen(e.target.value)}
                      />
                      <img
                        className="mr-2"
                        src="assets/img/my-profile/blue-cross.png"
                        aria-hidden="true"
                        onClick={() => {setOpen(false);setCoupen("")}}
                      />
                    </div>
                    <button
                      className="book--hexagon active"
                      style={{ margin: 0 }}
                      onClick={handleApplycoupen}
                    >
                      <span className="text-capitalize">Apply</span>
                    </button>
                  </div>
                )}
                {open && apply && (
                  <React.Fragment>
                    <div>
                      Coupon Discount{" "}
                      <span
                        className={styles.remove}
                        onClick={handleRemoveCoupen}
                      >
                        Remove
                      </span>
                    </div>
                    <div className={styles.rate}>₹100</div>
                  </React.Fragment>
                )}
              </div> */}
            </div>

            {totalPayble >= 0 ? (
              <div className={styles.cardTotal}>
                <div>Total Payable Amount</div>
                <div className={styles.rate}>₹{totalPayble || 0}</div>
              </div>
            ) : (
              <div className={styles.cardTotal}>
                <div>Total Refundable Amount</div>
                <div className={styles.rate}>₹{totalPayble?.toString()?.replace("-", "")}</div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default CartBox;
